module.exports = __webpack_public_path__ + "static/media/ig14.77995b5e.jpg";